export const REFERENCE_TABLE_DEVIS = 'tableListeDevis';
export const REFERENCE_TABLE_COMMANDE = 'tablelisteCommandes';
export const REFERENCE_TABLE_COMMANDE_A_FACTURER = 'tableListeEcommandeAFacturer';
export const REFERENCE_TABLE_LISTE_ECHEANCES = 'tablelisteEcheances';
export const REFERENCE_TABLE_RENOUVELLEMENT_COMMANDES = 'tableRenouvellementCommande';
export const REFERENCE_TABLE_LIGNES_COMMANDES = 'tablelisteLignesCommandes';
export const REFERENCE_TABLE_LIGNES_COMMANDES_A_RENOUVELER = 'tablelisteLignesCommandesARenouveler';
export const REFERENCE_TABLE_LISTE_FACTURE = 'tablelisteFactures';
export const REFERENCE_TABLE_LIGNES_DEVIS = 'tablelisteLignesDevis';
export const REFERENCE_TABLE_LISTE_LIGNES_FACTURE = 'tablelisteLignesFactures';
export const REFERENCE_TABLE_ECHEANCE_PAIEMENT = 'tableEcheancePaiement';
export const REFERENCE_TABLE_RETARD_PAIEMENT = 'tableRetardPaiement';
export const REFERENCE_TABLE_RELANCE_SAVE = 'tabRelancesSave';
export const REFERENCE_TABLE_RETROCESSION = 'tableRetrocession';
export const REFERENCE_TABLE_CLIENT = 'tableListeClients';
export const REFERENCE_TABLE_ENCOURS = 'tablelisteEnCours';
export const REFERENCE_TABLE_COMPTE_TIERS = 'pieces';
export const REFERENCE_TABLE_VENTES = 'tableVentes';
export const REFERENCE_TABLE_DEVIS_CLIENT = 'tableDevisClient';
export const REFERENCE_TABLE_FACTURE_CLIENT = 'tableFactureClient';
export const REFERENCE_TABLE_ECHEANCES = 'tableEcheances';
export const REFERENCE_TABLE_RELANCE_CLIENT = 'tabRelancesClient';
export const REFERENCE_TABLE_CONTACTS = 'tableListeContacts';
export const REFERENCE_TABLE_LISTE_PRODUIT = 'tableListeProduits';
export const REFERENCE_TABLE_LISTE_PRODUIT_NON_COM = 'tableListeProduitsNonCom';
export const REFERENCE_TABLE_PRODUIT_RESEAU_TEMPO = 'tableListeProduitsReseauTempo';
export const REFERENCE_TABLE_PRODUIT_RESEAU_LC = 'tableListeProduitsReseauLc';
export const REFERENCE_TABLE_PRODUIT_RESEAU_MAIRIE = 'tableListeProduitsReseauMairie';
export const REFERENCE_TABLE_PRODUIT_RESEAU_NUMERIQUE = 'tableListeProduitsReseauNumerique';
export const REFERENCE_TABLE_PRODUIT_FACE = 'tableListeProduitsFace';
export const REFERENCE_TABLE_SUIVI_AFFECTATION_PRODUIT_FACE = 'tableListeSuiviAffectationProduitsFace';
export const REFERENCE_TABLE_PRODUIT_ECRAN = 'tableListeProduitsEcran';
export const REFERENCE_PLANNING_FACE = 'tableFaceUnitaire';
export const REFERENCE_PLANNING_RESEAU_TEMPO = 'tableReseauTempoDispo';
export const REFERENCE_PLANNING_RESEAU_LC = 'tableReseauLc';
export const REFERENCE_PLANNING_NUMERIQUE = 'tableEcranNumerique';
export const REFERENCE_PLANNING_RESEAU_NUMERIQUE = 'tableReseauNumerique';
export const REFERENCE_OUTIL_PRODUIT_RESEAU_TEMPO = 'tableListeProduitsReseauTempoOutil';
export const REFERENCE_TABLE_LISTE_FACTOR = 'tablelisteFactor';
export const REFERENCE_TABLE_LISTE_TRANSMISSION = 'tablelisteTransmissions';
export const REFERENCE_PLANNING_AJOUT_FACE = 'tablePlanningFaceUnitaire';
export const REFERENCE_PLANNING_AJOUT_RESEAU_TEMPO = 'tablePlanningReseauTempoDispo';
export const REFERENCE_PLANNING_AJOUT_RESEAU_LC = 'tablePlanningReseauLc';
export const REFERENCE_PLANNING_AJOUT_NUMERIQUE = 'tablePlanningEcranNumerique';
export const REFERENCE_PLANNING_AJOUT_RESEAU_NUMERIQUE = 'tablePlanningReseauNumerique';
export const REFERENCE_PLANNING_AJOUT_RESEAU_MAIRIE = 'tablePlanningReseauMairie';
export const REFERENCE_TABLE_EMPLACEMENT = 'tableEmplacement';
export const REFERENCE_TABLE_DISPOSITIF = 'tabDispositifs';
export const REFERENCE_TABLE_MATERIEL = 'tabMateriels';
export const REFERENCE_TABLE_FACES = 'tabFaces';
export const REFERENCE_TABLE_COLLECTIVITES = 'tableListeCollectivite';
export const REFERENCE_TABLE_MATERIELS_TLPE = 'tabMaterielsTlpe';
export const REFERENCE_TABLE_DECLARATIONS = 'tableListeDeclarations';
export const REFERENCE_TABLE_DECLARATIONS_AU_FIL_DE_LEAU = 'tableListeDeclarationsFilDeLeau';
export const REFERENCE_TABLE_COMMANDES_TLPE = 'tableCommandeTlpe';
export const REFERENCE_TABLE_CONFRERES = 'tablelisteConfrere';
export const REFERENCE_TABLE_FOURNISSEUR_MAT = 'tablelisteFournisseurMat';
export const REFERENCE_TABLE_INFO_COMMANDE_TLPE = 'tableInfoCommandeTlpe';
export const REFERENCE_TABLE_LISTE_SIGNATURE = 'tableListeSignatures';
export const REFERENCE_TABLE_JOURNAL_EXERCICE = 'tablejournalExercice';
export const REFERENCE_TABLE_LOTS_COMPTABLE = 'tableLotsComptable';
export const REFERENCE_TABLE_LISTE_ECRITURE_COMPTABLE = 'tableListeEcritureComptable';
export const REFERENCE_TABLE_OPERATION_DIVERSE = 'tableOperationDiverse';
export const REFERENCE_TABLE_MOIS_COMPTABLE = 'tableMoisComptable';
export const REFERENCE_TABLE_EXERCICE_COMPTABLE = 'tableExerciceComptable';
export const REFERENCE_TABLE_FOURNISSEUR_SUPPORT = 'tableListeFournisseurSupport';
export const REFERENCE_TABLE_LISTE_PARUTION = 'tableListeParution';
export const REFERENCE_TABLE_LISTE_PLAN_MEDIA = 'tableListePlanMedia';
export const REFERENCE_TABLE_LISTE_MARCHE = 'tableListeMarche';
export const REFERENCE_TABLE_PRODUIT_PRESSE = 'tableListeProduitPresse';
export const REFERENCE_TABLE_PRODUIT_SALON = 'tableListeProduitSalon';
export const REFERENCE_TABLE_PRODUIT_SPONSORING = 'tableListeProduitSponsoring';
export const REFERENCE_TABLE_PRODUIT_AUTRE = 'tableListeProduitAutre';
export const REFERENCE_TABLE_REGROUPEMENT_PRODUITS = 'tableListeRegroupementProduits';
export const REFERENCE_TABLE_LISTE_CONTRAT = 'tableListeContrat';
export const REFERENCE_TABLE_LISTE_CONTRAT_RECONDUCTIBLE = 'tableListeContratReconductible';
export const REFERENCE_TABLE_LISTE_CONTRAT_MATERIEL = 'tableListeContratMateriel';
export const REFERENCE_TABLE_CONSTATATION_CHARGE = 'tableConstatationCharge';
export const REFERENCE_TABLE_LISTE_FACTURE_ACHAT = 'tableListeFactureAchat';
export const REFERENCE_TABLE_ECHEANCES_A_PAYER = 'tableEcheancesAPayer';
export const REFERENCE_TABLE_PAIEMENT_SUR_PAIEMENT = 'tablePaiementSurFacture';
export const REFERENCE_TABLE_FACTURES_NON_PARVENUES = 'tableFactureNonParvenue';
export const REFERENCE_TABLE_LISTE_PRODUITS_ACHATS = 'tableListeProduitsAchat';
export const REFERENCE_TABLE_LISTE_BAILLEURS = 'tableListeBailleur';
export const REFERENCE_TABLE_LISTE_DEMARCHEURS = 'tableListeDemarcheur';
export const REFERENCE_TABLE_LISTE_INTERVENTION = 'tableIntervention';
export const REFERENCE_TABLE_PREVISIONNEL_DEPART = 'tabPrevisionnelDepart';
export const REFERENCE_TABLE_DEMANDE = 'tableDemande';
export const REFERENCE_TABLE_DEMANDE_AUTO = 'tableDemandeAuto';
export const REFERENCE_TABLE_ORDRE_TRAVAIL_AFFICHAGE = 'tableOrdreTravailAffichage';
export const REFERENCE_TABLE_CHARGE_TRAVAIL_TECH = 'tableChargeTravailTech';
export const REFERENCE_TABLE_ORDRE_TRAVAIL_TECH = 'tableOrdreTravailTech';
export const REFERENCE_TABLE_AUDIT = 'tableAudit';
export const REFERENCE_TABLE_LISTE_AFFICHEURS = 'tableListeAfficheur';
export const REFERENCE_TABLE_LISTE_TECHNICIENS = 'tablelisteTechnicien';
export const REFERENCE_TABLE_TOURNEE_MODELE = 'tableTourneeModele';
export const REFERENCE_TABLE_LISTE_CAMPAGNE = 'tableListeCampagne';
export const REFERENCE_TABLE_REMISE_BANCAIRE = 'tableRemiseBancaire';
export const REFERENCE_TABLE_LOTS_PAIEMENTS = 'tableLotsPaiements';
export const REFERENCE_TABLE_LISTE_AFFECTATIONS_LOGISTIQUE = 'tableListeAffectionsLogistique';
export const REFERENCE_TABLE_GESTION_AFFECTATIONS = 'tableGestionAffectations';
export const REFERENCE_TABLE_LISTE_CHARGE_TRAVAIL = 'tableListeChargeTravail';
export const REFERENCE_TABLE_REMPLACEMENT_FACE_OT = 'tableRemplacementFaceOT';
export const REFERENCE_TABLE_AJOUT_FACE_OT = 'tableAjoutFaceOT';
export const REFERENCE_TABLE_DEMANDE_FACES_DISPONIBLES = 'tableDemandeFacesDisponibles';
export const REFERENCE_TABLE_GESTION_DEMANDE_AFFECTATION = 'tableGestionDemandeAffectation';
export const REFERENCE_TABLE_GESTION_DEMANDE_MANUEL_AFFECTATION = 'tableGestionDemandeManuelAffectation';
export const REFERENCE_TABLE_LISTE_RESTRICTION = 'tableListeRestriction';
export const REFERENCE_TABLE_TOURNEE_FACE_SEMAINE = 'tableTourneeFaceSemaine';
export const REFERENCE_TABLE_ORGANISATION = 'tableOrganisation';
export const REFERENCE_TABLE_JOURNAL_REGLEMENTS = 'tableJournalReglements';
export const REFERENCE_TABLE_JOURNAL_PAIEMENTS = 'tableJournalPaiements';
export const REFERENCE_TABLE_MOUVEMENTS_STOCK = 'tableMouvementsStock';
export const REFERENCE_TABLE_DEMANDE_IMPRESSION = 'tableDemandeImpression';
export const REFERENCE_TABLE_SECTEUR_UTILISATEUR = 'tableSecteurUtilisateur';
export const REFERENCE_TABLE_LIEU_DE_LIVRAISON = 'tableLieuDeLivraison';
export const REFERENCE_TABLE_EXPEDITION_LIVRAISON = 'tableExpeditionLivraison';
export const REFERENCE_TABLE_OT_IMPRESSION = 'tableOrdreTravailImpression';
export const REFERENCE_TABLE_COMMANDE_ACHAT = 'tableListeCommandeAchat';
export const REFERENCE_TABLE_LISTE_TITRE_RECETTE = 'tableListeTitreRecette';
export const REFERENCE_TABLE_TITRE_RECETTE_COLLECTIVITE = 'tableTitreRecetteCollectivite';
export const REFERENCE_TABLE_LISTE_BON_EXPEDITION = 'tableListeBonExpedition';
export const REFERENCE_TABLE_LOT_PAIEMENT_RECETTE = 'tableLotsPaiementsRecette';
export const REFERENCE_TABLE_JOURNAL_PAIEMENT_RECETTE = 'tableJournalPaiementsRecette';
export const REFERENCE_TABLE_LISTE_PRODUITS_SUR_REGROUPEMENT = 'tableListeProduitsSurRegroupement';
export const REFERENCE_TABLE_ETAT_HISTORIQUE = 'tableListePatrimoineEtatHistorique';
export const REFERENCE_TABLE_SPRINT = 'tableSprint';
export const REFERENCE_TABLE_LISTE_FOURNISSEURS = 'tableListeFournisseurs';
export const REFERENCE_TABLE_COMPETENCES_FOURNISSEUR = 'tableCompetencesFournisseur';
export const REFERENCE_TABLE_FORMAT_AFFICHE = 'tableListeFormatAffiche';
export const REFERENCE_TABLE_SERVICE = 'tableListeService';
export const REFERENCE_TABLE_SERVICE_UTILISATEUR = 'tableListeServiceUtilisateur';
export const REFERENCE_TABLE_LISTE_COMMANDES_ACHAT_FOURNISSEUR = 'tableListeCommandesAchatFournisseur';
export const REFERENCE_TABLE_LIGNES_COMMANDES_ACHAT = 'tablelisteLignesCommandesAchat';
export const REFERENCE_TABLE_COMMANDE_CMDE_ACHAT = 'tableListeCommandeCmdAchat';
export const REFERENCE_TABLE_LISTE_BON_RECEPTION = 'tableListeBonReception';
export const REFERENCE_TABLE_LISTE_FACTURES_ACHAT_FOURNISSEUR = 'tableListeFacturesAchatFournisseur';
export const REFERENCE_TABLE_PRODUIT_RESEAU = 'tableListeProduitsReseau';
export const REFERENCE_TABLE_LISTE_PAIEMENTS_FACTURES = 'tableListePaiementsFactures';
export const REFERENCE_TABLE_JOURNAL_PAIEMENT_FACTURES_ACHAT = 'tableJournalPaiementsFacturesAchat';
export const REFERENCE_TABLE_LOT_PAIEMENT_FACTURES = 'tableLotsPaiementsFactures';
export const REFERENCE_TABLE_SUIVI_TACHES_INTERNES = 'tableListeSuiviTachesInternes';
export const REFERENCE_TABLE_AFFICHES = 'tableListeAffiches';
export const REFERENCE_TABLE_LIGNES_CMDES_ACHAT_CV = 'tablelisteLignesCmdeAchatDansCV';
